import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import axios from "../../utils/AxiosInstance";

const CarDetails = () => {
  const { id } = useParams();
  const [carDetail, setCarDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCarDetails = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`/car/get/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCarDetail(res.data.data);
      } catch (error) {
        console.log(error);
        
        console.error("Error fetching car details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCarDetails();
  }, [id]);

  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!carDetail) {
    return <p className="text-center">Car not found</p>;
  }

  return (
    <div className="container mt-4">
      <h4 className="mb-4 text-center">Car Details</h4>
      <table className="table table-bordered">
        <tbody>
          <tr>
            <th>Title</th>
            <td>{carDetail.title}</td>
          </tr>
          <tr>
            <th>Brand</th>
            <td>{carDetail.brand}</td>
          </tr>
          <tr>
            <th>Model</th>
            <td>{carDetail.model}</td>
          </tr>
          <tr>
            <th>Category</th>
            <td>{carDetail.category?.name}</td>
          </tr>
          <tr>
            <th>Price</th>
            <td>{carDetail.price}</td>
          </tr>
          <tr>
            <th>Year</th>
            <td>{carDetail.year}</td>
          </tr>
          <tr>
            <th>Mileage</th>
            <td>{carDetail.mileage}</td>
          </tr>
          <tr>
            <th>Fuel Type</th>
            <td>{carDetail.fuelType}</td>
          </tr>
          <tr>
            <th>Transmission</th>
            <td>{carDetail.transmission}</td>
          </tr>
          <tr>
            <th>Description</th>
            <td>{carDetail.description}</td>
          </tr>
          <tr>
            <th>Images</th>
            <td>
              <div className="d-flex flex-wrap gap-2">
                {carDetail.images?.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt="car"
                    style={{
                      height: "100px",
                      width: "200px",
                      objectFit: "cover",
                    }}
                  />
                ))}
              </div>
            </td>
          </tr>
          <tr>
            <th>Status</th>
            <td>{carDetail.isActive ? "Active" : "Inactive"}</td>
          </tr>
        </tbody>
      </table>

      <div className="text-end">
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>
    </div>
  );
};

export default CarDetails;
